import { Dropdown, Form } from "semantic-ui-react";
import React from "react";
import { Portfolio, PortfolioLifestyleTemplate } from "../../../../services/PortfolioApi";
import { MatchingDatesPartial } from "../../../../components/MatchingDatesPartial";

// Updated interface to include portfolioError prop
interface NetworkCreationFormPiecesProps {
  networkNameError: boolean;
  l1DescError: boolean;
  importTypeError: boolean;
  portfolioError: boolean;
  aptError: boolean;
  setValue: (value: string | boolean, field: string) => void;
  portfolios: Portfolio[];
}

const generateValue = (x: any) => ({
  key: x,
  value: x.toUpperCase(),
  text: x,
});

const generatePortfolioValues = (x: Portfolio) => ({
  key: x.id,
  value: x.id as any,
  text: x.name,
});

export const NetworkCreationFormPieces: React.FunctionComponent<NetworkCreationFormPiecesProps> = ({
  networkNameError,
  l1DescError,
  importTypeError,
  portfolioError,
  aptError,
  setValue,
  portfolios
}) => {
  const portfolioTypes = portfolios.map(generatePortfolioValues);
  const importTypes = ["Open", "Passcode", "Cbord", "Rms", "Rmbg", "Entrata", "Acc"].map(generateValue);


  return (
    <>
      <Form.Field error={networkNameError}>
        <label>Network Name</label>
        <input
          placeholder="Network Name"
          onChange={(event) => {
            // setInfo({...info, networkName: event.target.value})
            setValue(event.target.value, "networkName");
          }}
        />
      </Form.Field>

      <Form.Field error={l1DescError}>
        <label>Network Description</label>
        <textarea
          placeholder="Network Description"
          onChange={(event) => {
            // setInfo({...info, l1Desc: event.target.value})
            setValue(event.target.value, "l1Desc");
          }}
        />
      </Form.Field>

      <Form.Field error={importTypeError}>
        <label>Import Type</label>
        <Dropdown
          placeholder="Import Type"
          options={importTypes}
          selection
          fluid
          onChange={(event, data) => {
            // setInfo({...info, importType: data.value as string})
            setValue(data.value as string, "importType");
          }}
        />
      </Form.Field>

      <Form.Field error={portfolioError}>
        <label>Portfolio</label>
        <Dropdown
          placeholder="Portfolio"
          options={portfolioTypes}
          selection
          fluid
          onChange={(event, data) => {
            // setInfo({...info, importType: data.value as string})
            setValue(data.value as string, "portfolio");
          }}
        />
      </Form.Field>

      <Form.Field error={aptError}>
        <label>Is Apartment</label>
        <Dropdown
          placeholder="Is Apartment"
          options={[
            { value: false, text: "No" },
            { value: true, text: "Yes" },
          ]}
          selection
          fluid
          onChange={(event, data) => {
            // setInfo({...info, apt: data.value as boolean})
            setValue(data.value as boolean, "apt");
          }}
        />
      </Form.Field>
    </>
  );
};

interface SubNetworkCreationPiecesProps {
  subnetworkNameError: boolean;
  matchingDatesError: boolean;
  setValue: (value: string | boolean | null, field: string) => void;
}

export const SubNetworkCreationPieces: React.FunctionComponent<SubNetworkCreationPiecesProps> = ({
  subnetworkNameError,
  matchingDatesError,
  setValue,
}) => (
  <>
    <Form.Field error={subnetworkNameError}>
      <label>Matching Round Name</label>
      <input
        placeholder="Matching Round Name"
        onChange={(event) => {
          setValue(event.target.value, "subnetworkName");
        }}
      />
    </Form.Field>
    <Form.Field>
      <label>Matching Dates</label>
      <MatchingDatesPartial setValue={setValue} matchingDatesError={matchingDatesError} />
    </Form.Field>
  </>
);

interface UnitCreationPiecesProps {
  unitTypeNameError: boolean;
  unitSizeError: boolean;
  templates?: PortfolioLifestyleTemplate[];
  setValue: (value: string | boolean | number, field: string) => void;
}

const generateTemplateValues = (x: PortfolioLifestyleTemplate) => ({
  key: x.id,
  value: x.id as any,
  text: x.name,
});

export const UnitCreationPieces: React.FunctionComponent<UnitCreationPiecesProps> = ({
  unitTypeNameError,
  unitSizeError,
  templates,
  setValue,
}) => {
  const templateTypes = templates ? templates.map(generateTemplateValues) : undefined;
  return (
    <>
      <Form.Field error={unitTypeNameError}>
        <label>Unit Type Name</label>
        <input
          placeholder="Unit Type Name"
          onChange={(event) => {
            setValue(event.target.value, "unitTypeName");
          }}
        />
      </Form.Field>
  
      <Form.Field error={unitSizeError}>
        <label>Unit Size</label>
        <input
          type="number"
          placeholder="Unit size"
          onChange={(event) => {
            setValue(parseInt(event.target.value), "unitSize");
          }}
        />
      </Form.Field>
      {templateTypes && templateTypes.length > 0 && (
      <Form.Field error={unitSizeError}>
        <label>Portfolio Templates</label>
        <Dropdown
          placeholder="Lifestyle questions templates available in given Portfolio"
          options={[...templateTypes, {key: 'None', value: '', text: 'None'}]}
          selection
          fluid
          onChange={(event, data) => {
            // setInfo({...info, importType: data.value as string})
            setValue(data.value as string, "templateId");
          }}
        />
      </Form.Field>)}
    </>
  );
};

interface RoomCreationPiecesProps {
  nameError: boolean;
  numberInL3Error: boolean;
  setValue: (value: string | boolean | number, field: string) => void;
}

export const RoomCreationPieces: React.FunctionComponent<RoomCreationPiecesProps> = ({
  nameError,
  numberInL3Error,
  setValue,
}) => (
  <>
    <Form.Field>
      <label>Room Name</label>
      <input
        placeholder="Room Name"
        onChange={(event) => {
          setValue(event.target.value, "roomName");
        }}
      />
    </Form.Field>

    <Form.Field>
      <label>Rooms in l3</label>
      <input
        type="number"
        placeholder="Rooms in l3"
        onChange={(event) => {
          setValue(parseInt(event.target.value), "numberInL3");
        }}
      />
    </Form.Field>
  </>
);
